<template>
  <div
    id="producer"
    v-loading="querySubLoading">
    <div
      v-if="paySuccess"
      class="paysuccess-info">
      <img
        class="all-right"
        src="@/assets/svg/allright.svg"
        alt="">
      <div class="pay-start">PAYMENT COMPLETE</div>
      <div class="pay-info">
        Thank you, your payment has been successful.
        You can start use it now.
      </div>
      <div class="info-line"></div>
      <div class="pay-content">
        <div
          class="info-item"
          v-for="[key, value] in Object.entries(payInfo)"
          :key="key">
          <span>{{ key }}</span>
          <span>{{ value }}</span>
        </div>
      </div>
      <div class="trial-footer">
        <div
          class="close"
          @click="handleCloseIframe">
          Close
        </div>
      </div>
    </div>
    <choose-plan
      v-else-if="!hasSub &&!querySubLoading"
      @titlechange="titlechange"
      @reselectPlan="reselectPlan"
      :existPlan="subscription"></choose-plan>
    <Manage
      v-else-if="hasSub &&!querySubLoading"
      :plan="subscription"
      @reselectPlan="reselectPlan"></Manage>
  </div>
</template>

<script>
import ChoosePlan from './ChoosePlan.vue'
import Manage from './Manage.vue'
import { userHasSubscription } from '@/common/checkuser.js'
import { mapState } from 'vuex'
export default {
  components: {
    ChoosePlan,
    Manage
  },
  data () {
    return {
      querySubLoading: true,
      subscription: null,
      hasSub: false,
      paySuccess: false,
      payInfo: {}
    }
  },
  provide () {
    return {
      emailid: this.emailid,
      loadData: () => {
        this.querySubStatus()
      },
      paySuccess: (value) => {
        this.handlePaySuccess(value)
      }
    }
  },
  created () {
    this.querySubStatus()
  },
  methods: {
    handlePaySuccess (value) {
      this.payInfo = value
      this.paySuccess = true
    },
    // 关闭弹窗
    handleCloseIframe () {
      const params = {
        type: 'close',
        from: 'billing'
      }
      window.parent.postMessage(params, '*')
      this.$store.commit('handleIframeData', null)
    },
    // 查询订阅状态
    querySubStatus () {
      this.querySubLoading = true
      const params = {
        product: 'Producer'
      }
      userHasSubscription(params).then(({ data }) => {
        const subPlans = data.subscription.subscriptions || []
        if (subPlans.length > 0) {
          // this.planisSub = subPlans.findIndex(i => i.planId === this.planDetail.id) > -1
          const item = subPlans[0]
          const InputNumber = item.chargeItems.find(i => i.addonId == 'producer-input-number')
          if (InputNumber.quantity == '4') {
            Object.assign(item, {
              background: 'linear-gradient(274.86deg, #BDCFF4 0%, #E6EDFA 100%)',
              color: '#252525',
              fakePlanName: '4× Input'
            })
          } else if (InputNumber.quantity == '8') {
            Object.assign(item, {
              background: 'linear-gradient(274.86deg, #E7AA4D 0%, #FFF4D3 100%)',
              color: '#33AB4F',
              fakePlanName: '8× Input'
            })
          }
          this.subscription = item
          this.hasSub = true
          this.$emit('titlechange', 'Manage Subscriptions')
        } else {
          this.hasSub = false
          this.$emit('titlechange', 'Choose a plan')
        }
        this.querySubLoading = false
      })
    },
    titlechange (value) {
      this.$emit('titlechange', value)
    },
    // 重新选择plan   true -> manage  false -> choose
    reselectPlan (isManage) {
      if (!isManage) {
        this.hasSub = false
        this.$emit('titlechange', '')
      } else {
        this.hasSub = true
        this.$emit('titlechange', 'Manage Subscriptions')
      }
    }
  },
  computed: {
    ...mapState({
      emailid: state => state.userInfo.email
    })
  }
}
</script>

<style lang="less" scoped>
#producer {
  min-width: 408px;
  min-height: 460px;
  .paysuccess-info {
    .info-line {
      width: calc(100% - 80px);
      margin: 20px auto;
      height: 1px;
      background: var(--dialog-border-color);
    }
    .pay-content {
      height: 200px;
      padding: 0 40px;
      margin: 20px 0;
      // border-top: 1px solid var(--dialog-border-color);
      .info-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
      }
    }
    .pay-start {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #444444;
      margin: 10px 0;
    }
    .pay-info {
      font-size: 14px;
      line-height: 16px;
      text-align: center;
      color: #979797;
      padding: 0 40px;
      word-break: break-word;
    }

    .all-right {
      margin-top: 50px;
    }
    .trial-footer {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: right;
      position: absolute;
      bottom: 0;
      .close {
        width: 60px;
        border: 1px solid var(--datepicker-inner-border-color);
        border-radius: 5px;
        padding: 5px 8px;
        float: right;
        margin-right: 10%;
        cursor: pointer;
      }
    }
  }
}
</style>
